import { businessConfig } from '../../../config/businessConfig';

export default function Founder() {
  return (
    <section className="section founder" id="poleth">
      <div className="container founder__layout">
        <figure className="founder__portrait">
          <img
            src={businessConfig.assets.founderImage}
            alt="Poleth, fundadora de Mujer Virtuosa"
            loading="lazy"
          />
          <figcaption>
            <span>{businessConfig.founderName}</span>
            <small>Fundadora · {businessConfig.foundedYear}</small>
          </figcaption>
        </figure>

        <div className="founder__content">
          <p className="eyebrow">Conoce a la fundadora</p>
          <h2 className="section-title">Hola, soy {businessConfig.founderName}.</h2>
          <p className="founder__lead">
            En {businessConfig.foundedYear} di vida a {businessConfig.businessName} desde mi admiración por el mundo de la belleza y el deseo de crear un espacio de trabajo más flexible.
          </p>
          <p>
            Mi forma de atender es cercana, personalizada y dedicada a cada detalle. Más que atender muchas citas, prefiero que cada clienta tenga un momento tranquilo, cuidado y pensado especialmente para ella.
          </p>
          <p>
            Quiero que este sea un espacio de confianza, relajación y amor propio, donde puedas potenciar tu belleza y regalarte un momento para ti.
          </p>
          <a className="text-link" href="#consulta">Conversemos sobre tu próxima cita <span aria-hidden="true">→</span></a>
        </div>
      </div>
    </section>
  );
}
